import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Form } from '@grandvisionhq/forms';

var StepForm = (_param)=> {
    var { configuratorId , onSubmit , children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "configuratorId",
        "onSubmit",
        "children",
        "className"
    ]);
    return React.createElement("form", {
        noValidate: true,
        onSubmit: onSubmit,
        id: configuratorId,
        "aria-label": rest['aria-label'],
        "data-t": rest['data-t'],
        className: classnames('step-form', className)
    }, children);
};
var ConnectedStepForm = (_param)=>{
    var { children , initialFormState , onChange , configuratorId , onSubmit , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "initialFormState",
        "onChange",
        "configuratorId",
        "onSubmit",
        "className"
    ]);
    const handleSubmit = React.useCallback(()=>onSubmit()
    , [
        onSubmit
    ]);
    return /*#__PURE__*/ React.createElement(Form, {
        name: configuratorId,
        "aria-label": rest['aria-label'],
        "data-t": rest['data-t'],
        className: classnames('step-form', className),
        initialFormState: initialFormState,
        onChange: onChange,
        onSubmit: handleSubmit
    }, children);
};

export { ConnectedStepForm, StepForm };
//# sourceMappingURL=StepForm.js.map
